import React, { useEffect } from 'react';
import { security, SESSION_CONFIG } from '../utils/security';

export function SessionManager({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Start session on component mount
    security.session.start();

    // Set up session validation interval
    const intervalId = setInterval(() => {
      if (!security.session.validate()) {
        // Session expired, reload the page
        window.location.reload();
      }
    }, 60000); // Check every minute

    // Set up activity listeners
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    const handleActivity = () => security.session.update();
    
    activityEvents.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Cleanup
    return () => {
      clearInterval(intervalId);
      activityEvents.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  // Check for suspicious behavior
  useEffect(() => {
    if (security.detectSuspiciousBehavior()) {
      console.warn('Suspicious behavior detected');
      // You could implement additional security measures here
    }
  }, []);

  return <>{children}</>;
}